import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

// 导入新言组件
import XyComponents from '@/packages/components/index'
// 导入动画库
import 'animate.css'
// svg图标
import 'virtual:svg-icons-register'
// 移动端调试工具
import VConsole from 'vconsole'
import { useMonitor } from './monitor'

import LGSdk from '@/packages/plugins/languageSDK/index'

import clickOutside from '@/packages/directives/clickOutside'

const { startMonitor } = useMonitor()

const app = createApp(App)
// 注册指令
app.directive('click-outside', clickOutside)
// 初始化多语言SDK
app.use(LGSdk)
app.use(createPinia())
app.use(router)
// 全局注册组件
app.use(XyComponents)

startMonitor({
  app,
  router
})

app.mount('#app')

const isDev = ['dev', 'local', 'stable', 'stable-me', 'stable-sa', 'stable-kor'].includes(import.meta.env.VITE_APP_ENV)
if (isDev) {
  const vConsole = new VConsole()
  console.log(vConsole) // 添加这行代码来使用 vConsole 对象
}
